<template>
  <div class="question-detail">
    <div class="detail-title">{{ caseName }}</div>
    <div class="detail-html">
      <div v-html="caseContent"></div>
      <div class="detail-btn">
        <div
          class="btn-reject"
          :class="{ 'btn-resoving': resovingChecked }"
          @click="resoving"
        >
          未解决
          <i class="btnIcon face2"></i>
        </div>
        <div
          class="btn-resove"
          :class="{ 'btn-resoving': resovedChecked }"
          @click="resoved"
        >
          已解决
          <i class="btnIcon face1"></i>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Toast } from "vant";
export default {
  name: "question_detail",
  data() {
    return {
      caseContent: "",
      caseName: "",
      caseId: 0,
      resovingChecked: false,
      resovedChecked: false,
      btnClick: false,
    };
  },
  methods: {
    resoved() {
      if (this.btnClick) {
        return;
      }
      let instance = Toast("已解决");
      setTimeout(() => {
        instance.close();
      }, 2000);
      this.resovingChecked = false;
      this.resovedChecked = true;
      this.btnClick = true;
    },
    resoving() {
      if (this.btnClick) {
        return;
      }
      Toast("谢谢反馈~");
      this.resovingChecked = true;
      this.resovedChecked = false;
      this.btnClick = true;
    },
    htmlDecode(str) {
      var s = "";
      if (str.length === 0) return "";
      s = str.replace(/&amp;/g, "&");
      s = s.replace(/&lt;/g, "<");
      s = s.replace(/&gt;/g, ">");
      s = s.replace(/&nbsp;/g, " ");
      s = s.replace(/&#39;/g, "'");
      s = s.replace(/&quot;/g, '"');
      s = s.replace(/<br>/g, "\n");
      return s;
    },
  },
  mounted() {
    this.caseContent = this.htmlDecode(localStorage.getItem("caseContent"));
    this.caseName = localStorage.getItem("caseName");
    this.caseId = localStorage.getItem("caseId");
  },
};
</script>
<style lang="scss" scoped>
.question-detail {
  width: 100%;
  min-height: 100vh;
  background-color: #f5f5f7;
  .detail-title {
    padding: 14px 16px;
    font-size: 16px;
    font-weight: 500;
    color: #212832;
    margin-bottom: 8px;
    line-height: 22px;
    background: #ffffff;
  }
  .detail-html {
    padding: 14px 16px 0 16px;
    background: #ffffff;
    line-height: 22px;
    font-size: 14px;
    color: #5d646e;
    overflow: hidden;
    .detail-btn {
      padding: 24px 0 56px 0;
      display: flex;
      display: -webkit-flex;
      justify-content: space-around;
      -webkit-justify-content: space-around;
      .btn-resove,
      .btn-reject {
        width: 100px;
        height: 30px;
        padding-left: 40px;
        line-height: 30px;
        border-radius: 16px;
        font-size: 12px;
        font-weight: 500;
        color: #8e949e;
        background: #f9fbfe;
        position: relative;
        .btnIcon {
          display: block;
          width: 45px;
          height: 50px;
          position: absolute;
          top: -10px;
          left: -10px;
        }
        .face1 {
          background: url("../../assets/img/iconFace1.png") no-repeat;
          background-size: contain;
        }
        .face2 {
          background: url("../../assets/img/iconFace2.png") no-repeat;
          background-size: contain;
        }
      }
    }
    .btn-resoving {
      color: #2a3039 !important;
      background: #fff0eb !important;
    }
  }
}
</style>
